export default "__VITE_ASSET__Cbv6sN0V__"